export default {
    delivery: {
        product: {
            tracking: "Sledování",
            quantity: "Množství"
        }
    }
}